class WishlistNotification extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.setupListeners()
  }

  setupListeners () {
    super.setupListeners()

    this.handleShowToastNotification =
      this.handleShowToastNotification.bind(this)

    this.handleClose = this.handleClose.bind(this)
    this.handleStartCloseFunction = this.handleStartCloseFunction.bind(this)
    this.handleStopCloseFunction = this.handleStopCloseFunction.bind(this)

    this.handleShowToastNotification()

    this.listeners.add(this.els.close.element, 'click', this.handleClose)
    this.listeners.add(this, 'mouseover', this.handleStopCloseFunction)
    this.listeners.add(this, 'mouseout', this.handleStartCloseFunction)
  }

  handleShowToastNotification () {
    window.SwymCallbacks = window.SwymCallbacks || []
    window.SwymCallbacks.push((swat) => {
      window._swat.evtLayer.addEventListener(
        window._swat.JSEvents.addedToWishlist,
        (data) => {
          const productTitle = data.detail.d.dt
          const productImage = data.detail.d.iu

          const listConfig = {
            lid: data.detail.d.lid,
          }

          const onSuccess = (listDetails) => {
            const listName = listDetails.list.lname

            this.els.media.element.innerHTML = productImage
              ? `<div class="rsp-Image"><img class="rsp-Image_Image" src="${productImage}" alt="${productTitle}"></div>`
              : ''
            this.els.title.element.innerHTML = `<strong>${productTitle}</strong> has been added to <strong>${listName}</strong> successfully.`
            this.setAttribute('aria-hidden', 'false')
            this.announce(this.els.title.element.textContent)
          }

          const onError = (error) => {
            this.handleClose()

            /* eslint-disable-next-line no-console */
            console.log('Error while fetching List details', error)
          }

          window._swat.fetchListDetails(listConfig, onSuccess, onError)
        },
      )
    })
  }

  announce (message) {
    const status = this.externalEls?.status?.element

    if (!status) return

    // Clearing first lets an identical repeat message still be announced.
    status.textContent = ''
    window.requestAnimationFrame(() => {
      status.textContent = message
    })
  }

  handleClose () {
    this.setAttribute('aria-hidden', 'true')

    const status = this.externalEls?.status?.element

    if (status) status.textContent = ''
  }

  handleStartCloseFunction () {
    // Keep the notification visible until the user dismisses it.
  }

  handleStopCloseFunction () {
    // Keep the notification visible until the user dismisses it.
  }
}

if (!customElements.get('wishlist-notification')) {
  customElements.define('wishlist-notification', WishlistNotification)
}
